<template lang="html">
  <div class="container">
    <div class="wrapper">
      <div class="header-box">
        <i class="icon-fanhui iconfont icon"  @click="$router.go(-1)"></i>
        <input v-model="selectedProject.project_name" type="text" placeholder="请输入项目名" name="" value="">
      </div>
      <mt-index-list>
        <mt-index-section  index="">
          <mt-cell  v-for="(item,index) in projectList" :title="item" :key="index" @click.native="chooseProject(item,index)" ></mt-cell>
        </mt-index-section>
      </mt-index-list>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import axios from 'axios'
  import { IndexList, IndexSection } from 'mint-ui';
  import { Search } from 'mint-ui';
  export default {
    data () {
      return {
        searchProjects: [],
        selectedProject: {
          project_name: '',
        },
        projectList: {},
      }
    },
    watch: {
      ['selectedProject.project_name'] (val) {
        this.$http.getProSearch({ project_name: val }).then(res => {
          this.projectList = res.data
        })
      }
    },
    methods: {
      chooseProject (name, orderId) {
        this.$router.push({ name: 'ticketapply', query: { name: name, orderId:orderId }})
      },

    },
    mounted () {
      this.projectList = this.$route.query.proList
    },

  }
</script>

<style lang="css" scoped>
  * {
    color: black;
    background: #fff;
  }
  .container,
  .wrapper {
    width: 100%;
    height: 100%;
  }

  .header-box {
    width: 100%;
    height: 1.5rem;
    line-height: 1.5rem;
    position: relative;
    border-bottom: 1px solid rgba(66, 75, 93, 0.5);
  }
  .header-box input {
    width: 86%;
    height: 1rem;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 5%;
    margin: auto;
    border-radius: 2px;
    background: #f4f4f4;
    padding-left: 3%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Ticket/AllProject.vue